/**
 * @format
 * @module ui-lightbox
 */

import ee from "lib/eventemitter";
import { qsa } from "utils/utils";
import tgamConfig from "config/tgam";

/**
 * @method openLightBox
 * @description creates a semi transparent black background for modals
 * @param {Object} c - collection or properties
 * @param {Boolean} [c.protectedModal = false] - whether the boolean is closable when they hit the close button or click outside the modal
 * @param {Function} [c.onCloseFunction = hideAllModals] - the method to call when the lightbox bg is clicked
 * @param {Array} [c.lightboxClasses = []] - additional CSS classes to be added to the lightbox element (default is an empty array)
 */
export function openLightBox({
  protectedModal = false,
  onCloseFunction = () => {},
  lightboxClasses = []
}) {
  closeOtherLightBoxes();

  const lightBoxBg = document.createElement("div");
  lightBoxBg.classList.add("c-lightbox");
  lightboxClasses.forEach(c => {
    lightBoxBg.classList.add(c);
  });

  document.body.appendChild(lightBoxBg);
  const closeCallback = closeModalCallback({ protectedModal, onCloseFunction });
  lightBoxBg.addEventListener("click", closeCallback);

  ee.trigger("lightbox:opened");
}

/**
 * @method closeModalCallback
 * @description composes a function callback based on modalConfig
 * @param {Object} c - collection of properties
 * @param {Boolean} c.protectedModal - whether or not the modal is protected
 * @param {Function} c.onCloseFunction - function to call when the close button is clicked
 * @returns {Function}
 */
export function closeModalCallback({ protectedModal, onCloseFunction }) {
  const goBackHome = () => (window.location.href = tgamConfig.env.baseHomepageUrl);
  return protectedModal ? goBackHome : onCloseFunction;
}

/**
 * @method closeLightBox
 * @description remove a single lightbox element from the DOM
 */
export function closeLightBox() {
  const lightBoxBg = document.querySelector(".c-lightbox");
  lightBoxBg && document.body.removeChild(lightBoxBg);
  ee.trigger("lightbox:closed");
}

/**
 * @method closeOtherLightBoxes
 * @description will look for other lightbox elements and will remove them from the DOM if they exist
 */
function closeOtherLightBoxes() {
  qsa(".c-lightbox").forEach(lightBoxElement => {
    lightBoxElement && document.body.removeChild(lightBoxElement);
  });
}
